'use strict';

var BaseStaticView = require('actions/shared/AbstractStaticView');
var tpl = require('actions/globalDns/static.html');
var twig = require('twig').twig;

/**
 * Renders a text-only version of the "Global DNS" component.
 */
module.exports = BaseStaticView.extend({
  /**
   * @name actions/globalDns/StaticView#model
   * @type {actions/globalDns/EditGlobalDns}
   */

  template: twig({data: tpl}),
});
